/**
 * Homepage + search size-rail adapter. UI only.
 */
if (!window.__quickSizeAddBound) {
  window.__quickSizeAddBound = true;

  document.addEventListener('click', (event) => {
    const sizeButton = event.target.closest('.sr-sizes__btn, .quick-size-add__size');
    if (!sizeButton) return;

    event.preventDefault();
    event.stopPropagation();
    if (sizeButton.classList.contains('is-oos') || sizeButton.disabled) return;
    if (!sizeButton.getAttribute('data-variant-id')) return;
    if (typeof window.QuickAddCore?.addVariant !== 'function') return;

    sizeButton.disabled = true;
    sizeButton.classList.add('is-adding');

    window.QuickAddCore.addVariant(sizeButton.getAttribute('data-variant-id'), 1)
      .then(() => {
        sizeButton.classList.add('is-added');
        setTimeout(() => sizeButton.classList.remove('is-added'), 900);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        sizeButton.classList.remove('is-adding');
        sizeButton.disabled = false;
      });
  });
}
